import { VidyoConnector } from "@/features/vidyo-call/types/vidyoclient-nativewebrtc-sdk";
import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

export async function createRecordingsLifecycle(
  vidyoConnector: VidyoConnector,
) {
  const setIsRecording = useVidyoStore.getState().setIsRecording;

  await Promise.all([
    vidyoConnector.RegisterRecorderInCallEventListener({
      onRecorderInCallChanged: (hasRecorderInCall) => {
        setIsRecording(hasRecorderInCall);
      },
    }),
  ]);
}
